<template>
  <div class="container-fluid">
    <div class="impressum-container">
      <h2>{{ title }}</h2>
      <div class="row">
        <div class="col-md-4">
          <div class="descriptiontext">
            <p>{{ description }}</p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="middle-container">
            <div class="img-container"><img :src="linkimage" alt="" /></div>
            <div class="btn-container">
              <!-- NOSONAR -->
              <a :href="buttonlink" role="button" class="">
                <strong>{{ buttontext }}</strong>
              </a>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="right-container">
            <img :src="image" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'mixa-impressum',
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
    linkimage: {
      type: String,
      required: true,
    },
    buttontext: {
      type: String,
      required: true,
    },
    buttonlink: {
      type: String,
      required: true,
    },
  },
};
</script>
